var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip494_454"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "interface-arrows-curvy-both-direction-2--both-direction-arrow-curvy-diagram-zigzag-horizontal--Streamline-Core",
    rx: 0,
    width: 19.333303,
    height: 19.333303,
    transform: "translate(0.333334 0.333334)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "interface-arrows-curvy-both-direction-2--both-direction-arrow-curvy-diagram-zigzag-horizontal--Streamline-Core",
    rx: 0,
    width: 19.333303,
    height: 19.333303,
    transform: "translate(0.333334 0.333334)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip494_454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.17 0.71L0.71 4.17L17.32 4.17C17.69 4.17 18.04 4.32 18.3 4.58C18.56 4.84 18.71 5.19 18.71 5.56L18.71 8.33C18.71 8.69 18.56 9.04 18.3 9.3C18.04 9.56 17.69 9.71 17.32 9.71L2.09 9.71C1.73 9.71 1.37 9.86 1.11 10.12C0.85 10.37 0.71 10.73 0.71 11.09L0.71 13.86C0.71 14.23 0.85 14.58 1.11 14.84C1.37 15.1 1.73 15.25 2.09 15.25L18.71 15.25L15.25 18.71",
    stroke: "#0000AC",
    strokeOpacity: 1,
    strokeWidth: 1.333334,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ac69c014f374c3160c05a704c20d7de8.svg";
export { ForwardRef as ReactComponent };